/** Documentos revisados en la subpestaña Factibilidad (cargados en la solicitud). */
export const FACTIBILIDAD_DOCS_SOLICITUD = [
  {
    key: "solicitud_documento_identidad",
    label: "Documento de identidad del solicitante",
    etapaKey: "solicitud_servicio",
  },
  {
    key: "solicitud_acreditacion_uso_especial",
    label: "Documento que acredita uso especial",
    etapaKey: "solicitud_servicio",
    soloUsoEspecial: true,
  },
] as const;

export const TIPO_DOC_IDENTIDAD_SOLICITUD = "solicitud_documento_identidad";
export const TIPO_DOC_ACREDITACION_USO_ESPECIAL = "solicitud_acreditacion_uso_especial";

export function docsFactibilidadParaTipoUso(tipoUso: string | undefined | null) {
  const uso = String(tipoUso || "").trim();
  return FACTIBILIDAD_DOCS_SOLICITUD.filter(
    (d) => !("soloUsoEspecial" in d && d.soloUsoEspecial) || uso === "Especial",
  );
}
